import { Tab, TabProps, Tabs, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { Link as RouterLink, Outlet, useNavigate } from "react-router-dom"
import { useParams } from 'react-router-dom';
import { Account } from "@models/account";
import { useLocation } from 'react-router-dom';
import { AccountProvider } from "@features/tickets/shared/contexts/AccountContext";
import { useErrorBoundary } from "react-error-boundary";
import { handleErrorWithBoundary } from "@shared/lib/errors"
import { useTheme } from "@emotion/react";
import { useGetAccountByIdQuery } from "@features/tickets/api/accounts.api";


interface LinkTabProps extends TabProps {
  path: string;
  selected?: string;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component={RouterLink}
      to={props.path}
      label={props.label}
      aria-current={props.selected ? 'page' : undefined}
      {...props}
    />
  );
}

// Define an array of tab hrefs
const tabsData = [
  {
    label: "פרטי כרטיס",
    path: "",
  },
  {
    label: "תנועות",
    path: "journal-entries",
  },
  // {
  //   label: "הסטוריה",
  //   path: "history",
  // },
];


function Bank() {

  const theme = useTheme();
  const { showBoundary } = useErrorBoundary();
  const location = useLocation();
  const navigate = useNavigate();

  const currentIndex = tabsData.findIndex(tab => tab.path !== "" && location.pathname.includes(tab.path));
  const value = currentIndex !== -1 ? currentIndex : 0;

 
  const [bank, setBank] = useState<Account | undefined>();
  const { id } = useParams();
  const { data: fetchedBank, error } = useGetAccountByIdQuery(id ?? "", {
    skip: !id || Boolean(location.state),
  });


  useEffect(() => {
    if(location.state){
      setBank(location.state);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, []);

  useEffect(() => {
    if (fetchedBank) {
      setBank(fetchedBank);
    }
  }, [fetchedBank]);

  useEffect(() => {
    if (error) {
      handleErrorWithBoundary(error, showBoundary);
    }
  }, [error, showBoundary]);

  {
    return bank && 
    <>
      <div>
        <Typography variant="h5" component="span">
          כרטיס בנק
        </Typography>

        <span>מס כרטיס: {bank?.card_number}</span>
      </div>

      <Tabs
        dir='ltr'
        value={value}
        //textColor="secondary"
        //indicatorColor="secondary"
        role="navigation"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        style={{ direction: "rtl", flexDirection: "row-reverse", backgroundColor: theme.colors.section_color, padding: 5, marginTop: 20 }}

      >
        {tabsData.map((tab, index) => (
          <LinkTab key={index} label={tab.label} path={tab.path} />
        ))}

      </Tabs>
      <AccountProvider account={bank}>
        <Outlet />
      </AccountProvider>
    </>
  }
}

export default Bank